import {
  Avatar,
  Button,
  DatePipe,
  EntityBadge,
  FileHashPipe,
  SanitizePipe,
} from '@abb-procure/common';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  input,
  output,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { NotificationInboxMessageModel } from '../../models/notification-inbox-message.model';

@Component({
  selector: 'procure-notification-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  imports: [
    Avatar,
    DatePipe,
    Button,
    MatTooltip,
    MatIcon,
    SanitizePipe,
    EntityBadge,
    FileHashPipe,
  ],
  host: {
    '[class.condensed]': 'condensed()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Message {
  readonly message = input.required<NotificationInboxMessageModel>();

  readonly condensed = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly toggleRead = output<MouseEvent>();
  readonly toggleArchive = output<MouseEvent>();
}
